/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2021, Zumper
 * @description
 */

import {
  selectCurrentKey,
  selectError,
  selectFetching,
  selectFetchingKey,
} from '@zcode/nr/es/shared/modules/meta/selectors'
import type { State } from '@zcode/state-type'
import { compose } from 'redux'

const selectShortTermAvailability = (state: State) => state.shortTermAvailability

export const selectVrboAvailability = compose(
  (state) => state.vrboAvailability,
  selectShortTermAvailability
)

export const selectVrboAvailabilityRoomTypes = compose(
  (state) => state?.roomTypes ?? [],
  selectVrboAvailability
)

export const selectVrboAvailabilityPrice = compose(
  (state) => state.price ?? {},
  selectVrboAvailability
)

export const selectVrboBaseRate = compose((state) => state.baseRate ?? '', selectVrboAvailability)

export const selectVrboTaxesAndFees = compose(
  (state) => state.taxesAndFees ?? '',
  selectVrboAvailability
)

export const selectVrboTotalPriceWithPropertyFees = compose(
  (state) => state.totalPriceWithPropertyFees ?? '',
  selectVrboAvailability
)

export const selectVrboAvgNightlyRate = compose(
  (state) => state.avgNightlyRate ?? '',
  selectVrboAvailability
)

export const selectVrboStatus = compose((state) => state.status ?? '', selectVrboAvailability)

export const selectVrboHref = compose((state) => state.href ?? '', selectVrboAvailability)

// meta
export const selectVrboAvailabilityMeta = compose(
  (state) => state.vrboMeta,
  selectShortTermAvailability
)

export const selectVrboAvailabilityErrorError = compose(selectError, selectVrboAvailabilityMeta)

export const selectVrboAvailabilityCurrentKey = compose(
  selectCurrentKey,
  selectVrboAvailabilityMeta
)

export const selectVrboAvailabilityFetching = compose(selectFetching, selectVrboAvailabilityMeta)

export const selectVrboAvailabilityFetchingKey = compose(
  selectFetchingKey,
  selectVrboAvailabilityMeta
)
